module.exports = __webpack_public_path__ + "static/media/Q6-7.91bd47e6.gif";